import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GradeService } from './gradeService';
import { GradeKey } from './keys';

export function useGetGroupGrades(groupId?: number, enabled = true) {
  const getGroupGradesQuery = useQuery({
    queryKey: [GradeKey.GROUP_GRADES, groupId],
    queryFn: () => GradeService.getGroupGrades(groupId).then((response) => response.data),
    enabled: enabled && typeof groupId === 'number',
  });
  const errorMessage = useErrorMessage(getGroupGradesQuery.error, baseErrorMessages);
  return { ...getGroupGradesQuery, errorMessage };
}
